<template>
  <div>
    <div class="fields">
      <div class="six column wide field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="role.name" />
      </div>
      <div class="seven column wide field">
        <label for>{{ $t("on login redirect to") }}</label>
        <div class="ui search selection dropdown" ref="redirect_to_dropdown">
          <input type="hidden" name="redirect_to" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("redirect route") }}</div>
        </div>
      </div>
      <div class="two column wide field">
        <label for>{{ $t("status") }}</label>
        <div class="ui toggle checkbox">
          <input type="checkbox" name="status" v-model="role.status" />
          <label>{{ $t("active") }}</label>
        </div>
      </div>
    </div>
    <div class="field">
      <label for>{{ $t("description") }}</label>
      <textarea
        name="description"
        rows="2"
        v-model="role.description"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoleModalGeneral",
  components: {},
  props: {
    role: Object,
  },
  methods: {
    setRedirectTo(login_redirect_to) {
      let vm = this;
      window
        .jQuery(vm.$refs.redirect_to_dropdown)
        .dropdown("set selected", login_redirect_to);
    },
  },
  mounted() {
    let vm = this;
    /**
     * Routes
     */
    let vls = vm.$router.options.routes
      .map((r) => {
        return { name: `${r.name} (${r.path})`, value: r.name };
      })
      .sort((a, b) => {
        if (a.value > b.value) return 1;
        else if (a.value < b.value) return -1;
        else return 0;
      });

    vls.unshift({ name: vm.$t("-none-"), value: "" });

    window
      .jQuery(vm.$refs.redirect_to_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value /* text, element */) {
          vm.role.login_redirect_to = value;
        },
      });
  },
};
</script>
